import { CLARITY_CHAT_EXTRACTABLE_DOCUMENT } from './constants/clarity-chat-extractable-document.constant';

/** Ported from Clarity `apps/web/src/shared/utils/documentUtils.ts` (commit `9015ce88c`). */
/**
 * Whether this document's text can be extracted in the browser (brain's `isExtractableDocument`, first read at brain
 * `e5fac7ff8`).
 *
 * True for docx, xlsx, xls, pptx, csv, html, htm and json — matched on the browser's MIME type
 * **or** on the file's own extension, because a browser reports nothing at all for several of them.
 *
 * The composer asks this to decide whether a file needs a pre-upload: what is read where the reader
 * is sitting is never written to temporary storage first (spec → TR-2(c)). A PDF is a document and
 * is **not** extractable here — its text is read on the far side — so it takes the upload route.
 *
 * **Both inputs are the reader's.** A declared MIME type and a file name are metadata a person's
 * machine supplied; a `true` here says which route to try, never that the bytes are what they claim.
 *
 * @param file The file the reader attached.
 */
export function isClarityChatExtractableDocument(file: File): boolean {
	const mimeTypes: readonly string[] = CLARITY_CHAT_EXTRACTABLE_DOCUMENT.MIME_TYPES;
	const extensions: readonly string[] = CLARITY_CHAT_EXTRACTABLE_DOCUMENT.EXTENSIONS;
	const name = file.name.toLowerCase();

	return mimeTypes.includes(file.type) || extensions.some(extension => name.endsWith(extension));
}
